module.exports = __webpack_public_path__ + "static/cf-med-ext-3d6285b8cd12658e7c49f49454a35c2e.ttf";